var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auth-template', [_c('registration-poster', {
    attrs: {
      "slot": "poster"
    },
    slot: "poster"
  }), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('auth-header', {
    attrs: {
      "title": _vm.$t('get.cash.now')
    }
  })], 1), _c('div', {
    class: _vm.$style.form
  }, [_c('registration-form', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }), _c('p', {
    class: _vm.$style.license,
    domProps: {
      "innerHTML": _vm._s(_vm.displayPrivacyText)
    }
  })], 1), _c('div', {
    class: _vm.$style.login
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('already.have.account')))]), _c('p', [_c('router-link', {
    attrs: {
      "to": "login",
      "data-test": "registrationRouterLink"
    }
  }, [_vm._v(_vm._s(_vm.$t('sign.in')))])], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }